import React from 'react'

import { Box, InputCheckBox, Skeleton } from '@factorialco/deprecated-design-system'

const SkeletonOption = () => {
  return (
    <Box
      alignItems="center"
      background="grey000White"
      cursor="default"
      flexDirection="row"
      gap="s16"
      paddingX="s16"
      paddingY="s12"
      width="full"
      border={{
        top: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
    >
      <Box flexDirection="row">
        <InputCheckBox checked={false} disabled />
      </Box>
      <Box flexDirection="column" gap="s8" padding="s8">
        <Skeleton height="s12" width="s80" />
        <Skeleton height="s16" width="s240" />
      </Box>
    </Box>
  )
}

export const SkeletonOptions = ({
  identifier,
  quantity,
}: {
  identifier: string
  quantity: number
}) => {
  return (
    <>
      {Array.from({ length: quantity }, (_, i) => (
        <SkeletonOption key={`${identifier}-${i}`} />
      ))}
    </>
  )
}
